// @flow
import type { ProductPurchasability } from "./publicpurchasable";

const convertToMap = (
    purchasability: ? any
  ): Map < number,
  ProductPurchasability > => {
    purchasability = purchasability || {};
    const output: Map < number, ProductPurchasability > = new Map();
    Object.entries(purchasability).forEach(([key, value]) => {
      var purchasabilityValue: ProductPurchasability;
      if (value === "IN_STORE_ONLY") {
        purchasabilityValue = "IN_STORE_ONLY";
      } else if (value === "CREATIVE_GLASS_ONLY") {
        purchasabilityValue = "CREATIVE_GLASS_ONLY";
      } else if (value === "ENQUIRE_ONLY") {
        purchasabilityValue = "ENQUIRE_ONLY";
      } else if (value === "PUBLIC") {
        purchasabilityValue = "PUBLIC";
      } else {
        purchasabilityValue = "MAX_ONLY";
      }
      output.set(parseInt(key), purchasabilityValue);
    });
    return output;
  };

export async function fetchPublicPurchasableData(
    productIds: number[]
): Promise<Map<number, ProductPurchasability>> {
  const data = await (await window.fetch(
      `/search/product/publicpurchasablestatus?productCodes=${productIds.join(
          ","
      )}`
  )).json();

  return convertToMap(data);
}


// WEBPACK FOOTER //
// ./javascript/product-search-page/public-purchasable/fetchPublicPurchasable.js